import { useRouter } from 'next/router';
import * as React from 'react';
import { useKanbanStore } from 'src/features/kanban';
import { useAuth } from 'src/shared/hooks/use-auth';

import { useBoardStore } from '../store/useBoardStore';
import { BoardView } from './BoardView';

const { useEffect } = React;

export const PublicBoard = () => {
  const router = useRouter();
  const boardsStore = useBoardStore();

  async function fetchPublicBoard() {
    useBoardStore.setState({ isLoading: true });
    await boardsStore.actions.fetchPublicBoardDetails({
      id: router.query.slug as string,
      boardId: router.query.view as string,
    });
    useBoardStore.setState({ isLoading: false });
  }

  useEffect(() => {
    boardsStore.actions.setIsPublicView(true);
    useAuth.setState({ isPublicFile: true });
    router?.query?.slug && fetchPublicBoard();
    router?.query?.slug && boardsStore.actions.fetchLabel({ id: router?.query?.slug as string });
    router?.query?.slug &&
      boardsStore.actions.fetchSelectables({ id: router?.query?.slug as string });
    useKanbanStore.setState({ isPublicView: true, isReadOnly: true });
    return () => {
      boardsStore.actions.resetState();
    };
  }, [router?.query?.slug]);

  return (
    <div className=" bg-gray-100 overflow-hidden pb-36">
      <div className="overflow-auto h-full">
        <BoardView type={router.query.type as string} id={router?.query?.view as string} />
      </div>
    </div>
  );
};
